// DO NOT MODIFY
// THIS FILE IS AUTOGENERATED BY
// rust-workspace/action-permissions/src/bin/generate_action_types.rs
// ANY CHANGES WILL BE OVERWRITTEN
// To regenerate this file, run `just generate-types`

import { z } from 'zod/v4';

export const ActionPermissionEnum = z.enum([
    'CanAccessCalculationTemplatesPage',
    'CanAccessCustomerPortalSettingsPage',
    'CanAccessCustomersTab',
    'CanAccessDesignSettingsPage',
    'CanAccessGeneralSettingsPage',
    'CanAccessOtherOrganizationSettingsPage',
    'CanAccessQuotationTab',
    'CanAccessRfqCalculationTab',
    'CanAccessSourcingSettingsPage',
    'CanAccessSupplierPortalSettingsPage',
    'CanAccessUserManagementSettingsPage',
    'CanAddInternalContributors',
    'CanAddSupportUser',
    'CanArchiveRfq',
    'CanCalculatePcbPrice',
    'CanCreateCalculationComment',
    'CanCreateCalculationForRfQ',
    'CanCreateCalculationTemplate',
    'CanCreateCustomer',
    'CanCreateDemandScenario',
    'CanCreateInternalAssemblyComment',
    'CanCreateInternalDesignItemComment',
    'CanCreateInternalRfqComment',
    'CanCreateInternalRole',
    'CanCreateManufacturer',
    'CanCreateManufacturerPreference',
    'CanCreateManufacturingInRfQ',
    'CanCreateManufacturingTemplates',
    'CanCreatePcb',
    'CanCreatePcbPanelPreference',
    'CanCreatePublicAssemblyComment',
    'CanCreatePublicDesignItemComment',
    'CanCreatePublicRfqComment',
    'CanCreateQuotationTemplate',
    'CanCreateRfq',
    'CanCreateSite',
    'CanDeleteCalculationForRfQ',
    'CanDeleteCalculationTemplate',
    'CanDeleteCustomer',
    'CanDeleteCustomerUser',
    'CanDeleteCustomerUserInvite',
    'CanDeleteDemandScenario',
    'CanDeleteInternalRole',
    'CanDeleteInternalUser',
    'CanDeleteInternalUserInvite',
    'CanDeleteManufacturerPreference',
    'CanDeleteManufacturingInRfQ',
    'CanDeleteManufacturingTemplates',
    'CanDeletePcbPanelPreference',
    'CanDeleteQuotationFile',
    'CanDeleteQuotationTemplate',
    'CanDeleteRfq',
    'CanDeleteSite',
    'CanDuplicateRfq',
    'CanEditAdditionalServices',
    'CanEditCheckoutConditions',
    'CanEditDemandScenario',
    'CanEditLandingPageTiles',
    'CanEditManufacturingKv',
    'CanEditPcb',
    'CanEditPcbPricing',
    'CanEditPcbQuotation',
    'CanEditProjectProgress',
    'CanEditQuotationTemplate',
    'CanEditRfq',
    'CanGetQuotationFile',
    'CanGetRfq',
    'CanGetSites',
    'CanGetWebhooksDashboardUrl',
    'CanInviteCustomerUsers',
    'CanInviteExternalContributors',
    'CanInviteInternalUsers',
    'CanRemoveSupportUser',
    'CanResolveAssemblyComment',
    'CanResolveCalculationComment',
    'CanResolveDesignItemComment',
    'CanResolveRfqComment',
    'CanUpdateAssemblySettings',
    'CanUpdateAutoRfqNumberSettings',
    'CanUpdateBomWarningConfigurationSettings',
    'CanUpdateCalculationForRfQ',
    'CanUpdateCalculationTemplate',
    'CanUpdateComponentSettings',
    'CanUpdateCustomer',
    'CanUpdateCustomerBillingAddress',
    'CanUpdateCustomerPortalSettings',
    'CanUpdateCustomerSpecificSettings',
    'CanUpdateCustomerUser',
    'CanUpdateDefaultPcbPanelPreferences',
    'CanUpdateImageAssets',
    'CanUpdateInternalRole',
    'CanUpdateInternalUser',
    'CanUpdateInternalUserRole',
    'CanUpdateLandingPageSettings',
    'CanUpdateMachineTokenRole',
    'CanUpdateManufacturer',
    'CanUpdateManufacturerPreference',
    'CanUpdateManufacturingInRfQ',
    'CanUpdateManufacturingTemplates',
    'CanUpdateOrganizationCurrencySettings',
    'CanUpdatePaymentCredentials',
    'CanUpdatePcbApiSettings',
    'CanUpdatePcbPanelPreference',
    'CanUpdateSelfSignupSettings',
    'CanUpdateSite',
    'CanUpdateSupplierPortalSettings',
    'CanUploadQuotationFile',
    'CanViewAssemblyComment',
    'CanViewAutoRfqNumberSettings',
    'CanViewAzureErpFiles',
    'CanViewBomWarningConfigurationSettings',
    'CanViewCalculationComment',
    'CanViewCalculationForRfQ',
    'CanViewCalculationTemplate',
    'CanViewComponentSettings',
    'CanViewCustomerSpecificSettings',
    'CanViewCustomerUserInvite',
    'CanViewDesignItemComment',
    'CanViewInternalRoles',
    'CanViewInternalUserInvite',
    'CanViewInternalUserRole',
    'CanViewMachineTokenRole',
    'CanViewManufacturingInRfQ',
    'CanViewManufacturingKv',
    'CanViewManufacturingTemplates',
    'CanViewOrganizationUsers',
    'CanViewPaymentCredentials',
    'CanViewPcb',
    'CanViewPcbCapabilities',
    'CanViewPcbPricing',
    'CanViewPcbQuotation',
    'CanViewProjectProgress',
    'CanViewQuotationTemplate',
    'CanViewRfqComment',
    'CanViewUserRoles',
]);
export type ActionPermission = z.infer<typeof ActionPermissionEnum>;
